import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import UserInfo from "./PodcasterComponents/UserInfo";
import eventBus from "../services/eventBus";

/**
 * Always-mounted host for the UserInfo modal. Open it from anywhere with:
 *   eventBus.emit('userinfo:open', { userGuid, clubGuid, context })
 */
function GlobalUserInfoModal() {
    const [target, setTarget] = useState(null);

    useEffect(() => {
        const handler = (payload) => {
            if (payload?.userGuid) setTarget(payload);
        };
        eventBus.on("userinfo:open", handler);
        return () => eventBus.off("userinfo:open", handler);
    }, []);

    return (
        <Modal show={!!target} onHide={() => setTarget(null)} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>User Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {target && (
                    <UserInfo
                        key={target.userGuid}
                        userGuid={target.userGuid}
                        clubGuid={target.clubGuid}
                        context={target.context ?? { type: 'club', data: {} }}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
}

export default GlobalUserInfoModal;
